import React from 'react';

import Button from '~/core/atoms/Buttons/Button';
import ActionArrowIcon from '~/core/iconComponents/icons/ActionArrowIcon';

interface DropZoneElementProps {
  isDragActive?: boolean;
  onClick: () => void;
}

export const DropZoneLabel: React.FC<DropZoneElementProps> = ({ isDragActive = false, onClick }) => (
  <div className="flex flex-col items-center justify-center gap-8 p-16 text-slate-800 transform-view">
    <div className="text-2xl">
      <ActionArrowIcon size={isDragActive ? 32 : 20} className="duration-300" />
    </div>
    <div>Drag & Drop your file here</div>
    <div className="mt-24">or</div>
    <Button
      className="bg-pink-600 px-12 py-8"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      BROWSE
    </Button>
  </div>
);
